module.exports = __webpack_public_path__ + "img/a10.c6ca734f.png";